/**
 * Created by scottrohrer on 8/27/15.
 */

/*
require.config({
    paths: {
        jquery: '../bower_components/jquery/dist/jquery',
        postal: "../bower_components/postal/lib/postal",
        lodash: "../bower_components/lodash/lodash"
    }
});
*/

define(["postal", "jquery"], function(postal, $) {
    labInfo = function() {

    };
    var instance = null;
    var channel = postal.channel("app");
    labInfo.prototype.getWorkbenchItems = function () {
        var returnVal = null;
        // var channel = postal.channel("app");
        console.log("getWorkbenchItems");
        var subscription = channel.subscribe("workbenchItems", function (data) {
            console.log("got 'em");
            returnVal = data.workbenchItems;
        });
        channel.publish("workbenchItemsRequest");
        function helper() {
            if (returnVal === null)
                return helper();
            else
                subscription.unsubscribe();
            return returnVal;
        }
        return helper();
    };
    labInfo.prototype.isFinishedLoading = function () {
        console.log("isFinishedLoading");
        var returnVal = false;
        var subscription = channel.subscribe("finishedLoading", function (data) {
            returnVal = data.finishedLoading;
        });
        channel.publish("finishedLoadingRequest");
        if (returnVal)
            subscription.unsubscribe();
        return returnVal;
    };
    labInfo.prototype.getSelectedItem = function () {
        var returnVal = null;
        console.log("getSelectedItem");
        var subscription = channel.subscribe("selectedVessel", function (data) {
            console.log("got it");
            returnVal = data.selectedVessel;
        });
        channel.publish("selectedVesselRequest");
        function helper() {
            if (returnVal === null)
                return helper();
            else
                subscription.unsubscribe()
            return returnVal;
        }
        return helper();
    };
    labInfo.prototype.loadAssignment = function() {
        var channel = postal.channel("app");
        channel.publish("loadAssignment", {});
    };
    labInfo.prototype.loadAssignmentJSON = function(data) {
        var channel = postal.channel("app");
        channel.publish("loadAssignmentJSON", data);
    };

    labInfo.getInstance = function() {
        if (instance === null) {
            instance = new labInfo();
        }
        return instance;
    };
    return labInfo.getInstance();
});